export default [{
    path: '/cash',
    name: 'cash',
    component: () => import ('@/views/pages/cash/cash-list/CashList.vue'),
    meta: {
        pageTitle: 'Cash',
        breadcrumb: [{ text: 'Cash', active: true }, ],
        resource: 'cash',
        action: 'read',
    },
},
{
    path: '/cash/view/:id',
    name: 'cash-view',
    component: () => import ('@/views/pages/cash/cash-view/CashView.vue'),
    meta: {
        pageTitle: 'View cash',
        breadcrumb: [
            { text: 'Cash', to:'/cash' }, 
            { text: 'View', active: true }
        ],
        resource: 'cash',
        action: 'read',
    },
},
{
    path: '/cash/edit/:id',
    name: 'cash-edit',
    component: () => import ('@/views/pages/cash/cash-edit/CashEdit.vue'),
    meta: {
        pageTitle: 'Edit cash',
        breadcrumb: [
            { text: 'Cash', to:'/cash' }, 
            { text: 'Edit', active: true }
        ],
        resource: 'cash',
        action: 'read',
    },
},
{
    path: '/cash/add',
    name: 'cash-add',
    component: () => import ('@/views/pages/cash/cash-add/CashAdd.vue'),
    meta: {
        pageTitle: 'Add cash',
        breadcrumb: [
            { text: 'Cash', to:'/cash' },
            { text: 'Add', active: true }
        ],
        resource: 'cash',
        action: 'read',
    }
}
]